import {
    getProduct,
    listProducts
} from './queries';
import {
    createProduct,
    deleteProduct,
    updateProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Product} from "../types.ts";
import {generateClient} from 'aws-amplify/api';
import {stripReadonlyFields} from '../../../utils/stripReadonlyFields';
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";

import {ListRecordsQuery} from "../../../types";

export type ListProducts = {
    listProducts: { items: Product[], nextToken: string }
}

export type GetProduct = {
    getProduct: Product
}

export type CreateProduct = {
    createProduct: Product
}

export type UpdateProduct = {
    updateProduct: Product
}

export type DeleteProduct = {
    deleteProduct: string
}


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListProducts>>({
            query: listProducts,
            variables: {...query},
        });
        return {
            items: response.data?.listProducts.items,
            nextToken: response.data?.listProducts.nextToken,
        };
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetProduct>>({
            query: getProduct,
            variables: {id: id},
        });
        return response.data?.getProduct;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const add = async (payload: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<CreateProduct>>({
            query: createProduct,
            variables: {input: payload},
        });
        notifySuccess('Product created');
        return response.data?.createProduct;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const update = async (_id: string, record: Product) => {
    const payload = stripReadonlyFields(record);
    try {
        const response = await client.graphql<GraphQLQuery<UpdateProduct>>({
            query: (updateProduct),
            variables: {input: payload},
        });
        notifySuccess('Product updated');
        return response.data?.updateProduct;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteProduct>>({
            query: (deleteProduct),
            variables: {input: {id: id}},
        });
        notifySuccess('Product deleted');
        return response.data?.deleteProduct;
    } catch (e) {
        notifyError(e);
        throw e;
    }
};
